import StandardGateway from './lib/standard_gateway';

export default class SkillGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/skills/:id');
  }

  fetchAll(params = {}) {
    let url = this.endpoint.set(params).fetchAllUrl;
    let config = params.excludeDisabled ? { params: { 'f.e': params.excludeDisabled } } : null;
    let resource = this.endpoint.patterns.fetchAllUrl;
    return this.http
      .get(url, config, resource)
      .then(dto => {
        this.observer.onFetchAllSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchAllError(error, params);
        throw error;
      });
  }
}
